import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import AuthLayout from '../layouts/AuthLayout.vue'
import AppLayout from '../layouts/AppLayout.vue'
import { useAuthStore } from '../stores/useAuthStore'

import RouteViewComponent from '../layouts/RouterBypass.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'login' },
  },
  {
    name: 'admin',
    path: '/admin',
    component: AppLayout,
    children: [
      {
        name: 'faq',
        path: 'faq',
        meta: { role: 0 },
        component: () => import('../pages/admin/pages/FaqPage.vue'),
      },
      {
        name: 'files',
        path: 'files',
        meta: { role: 1 },
        component: () => import('../pages/admin/forms/files.vue'),
      },
      {
        name: 'profile',
        path: 'profile',
        meta: { role: 0 },
        component: () => import('../pages/admin/pages/Profile.vue'),
      },
      {
        name: 'users',
        path: 'users',
        meta: { role: 1 },
        component: () => import('../pages/admin/forms/users.vue'),
      },
      {
        name: 'checking',
        path: 'checking',
        meta: { role: 1 },
        component: () => import('../pages/admin/forms/checking.vue'),
      },
      {
        name: 'statistics',
        path: 'statistics',
        meta: { role: 1 },
        component: () => import('../pages/admin/forms/statistics.vue'),
      },
      {
        name: 'monmanagement',
        path: 'monmanagement',
        meta: { role: 1 },
        component: () => import('../pages/admin/forms/monmanagement.vue'),
      },
      {
        name: 'pages',
        path: 'pages',
        meta: { role: 0 },
        component: RouteViewComponent,
        children: [
          {
            name: 'form_1',
            path: 'form_1',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_1.vue'),
          },
          {
            name: 'form_2',
            path: 'form_2',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_2.vue'),
          },
          {
            name: 'form_22',
            path: 'form_22',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_22.vue'),
          },
          {
            name: 'form_23',
            path: 'form_23',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_23.vue'),
          },
          {
            name: 'form_24',
            path: 'form_24',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_24.vue'),
          },
          {
            name: 'form_3',
            path: 'form_3',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_3.vue'),
          },
          {
            name: 'form_4',
            path: 'form_4',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_4.vue'),
          },
          {
            name: 'form_5',
            path: 'form_5',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_5.vue'),
          },
          {
            name: 'form_6',
            path: 'form_6',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_6.vue'),
          },
          {
            name: 'form_71',
            path: 'form_71',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_71.vue'),
          },
          {
            name: 'form_72',
            path: 'form_72',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_72.vue'),
          },
          {
            name: 'form_73',
            path: 'form_73',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_73.vue'),
          },
          {
            name: 'form_74',
            path: 'form_74',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_74.vue'),
          },
          {
            name: 'form_75',
            path: 'form_75',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_75.vue'),
          },
          {
            name: 'form_81',
            path: 'form_81',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_81.vue'),
          },
          {
            name: 'form_82',
            path: 'form_82',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_82.vue'),
          },
          {
            name: 'form_83',
            path: 'form_83',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_83.vue'),
          },
          {
            name: 'form_9',
            path: 'form_9',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_9.vue'),
          },
          {
            name: 'form_1011',
            path: 'form_1011',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_1011.vue'),
          },
          {
            name: 'form_1012',
            path: 'form_1012',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_1012.vue'),
          },
          {
            name: 'form_102',
            path: 'form_102',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_102.vue'),
          },
          {
            name: 'form_1031',
            path: 'form_1031',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_1031.vue'),
          },
          {
            name: 'form_1032',
            path: 'form_1032',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_1032.vue'),
          },
          {
            name: 'form_104',
            path: 'form_104',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_104.vue'),
          },
          {
            name: 'form_105',
            path: 'form_105',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_105.vue'),
          },
          {
            name: 'form_106',
            path: 'form_106',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_106.vue'),
          },
          {
            name: 'form_107',
            path: 'form_107',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_107.vue'),
          },
          {
            name: 'form_108',
            path: 'form_108',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_108.vue'),
          },
          {
            name: 'form_111',
            path: 'form_111',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_111.vue'),
          },
          {
            name: 'form_112',
            path: 'form_112',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_112.vue'),
          },
          {
            name: 'form_121',
            path: 'form_121',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_121.vue'),
          },
          {
            name: 'form_122',
            path: 'form_122',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_122.vue'),
          },
          {
            name: 'form_123',
            path: 'form_123',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_123.vue'),
          },
          {
            name: 'form_124',
            path: 'form_124',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_124.vue'),
          },
          {
            name: 'form_125',
            path: 'form_125',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_125.vue'),
          },
          {
            name: 'form_126',
            path: 'form_126',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_126.vue'),
          },
          {
            name: 'form_127',
            path: 'form_127',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_127.vue'),
          },
          {
            name: 'form_128',
            path: 'form_128',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_128.vue'),
          },
          {
            name: 'form_129',
            path: 'form_129',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_129.vue'),
          },
          {
            name: 'form_1210',
            path: 'form_1210',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_1210.vue'),
          },
          {
            name: 'form_1211',
            path: 'form_1211',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_1211.vue'),
          },
          {
            name: 'form_1212',
            path: 'form_1212',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_1212.vue'),
          },
          {
            name: 'form_131',
            path: 'form_131',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_131.vue'),
          },
          {
            name: 'form_132',
            path: 'form_132',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_132.vue'),
          },
          {
            name: 'form_133',
            path: 'form_133',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_133.vue'),
          },
          {
            name: 'form_134',
            path: 'form_134',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_134.vue'),
          },
          {
            name: 'form_135',
            path: 'form_135',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_135.vue'),
          },
          {
            name: 'form_141',
            path: 'form_141',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_141.vue'),
          },
          {
            name: 'form_142',
            path: 'form_142',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_142.vue'),
          },
          {
            name: 'form_151',
            path: 'form_151',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_151.vue'),
          },
          {
            name: 'form_152',
            path: 'form_152',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_152.vue'),
          },
          {
            name: 'form_153',
            path: 'form_153',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_153.vue'),
          },
          {
            name: 'form_154',
            path: 'form_154',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_154.vue'),
          },
          {
            name: 'form_161',
            path: 'form_161',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_161.vue'),
          },
          {
            name: 'form_162',
            path: 'form_162',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_162.vue'),
          },
          {
            name: 'form_171',
            path: 'form_171',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_171.vue'),
          },
          {
            name: 'form_172',
            path: 'form_172',
            meta: { role: 0 },
            component: () => import('../pages/admin/pages/form_172.vue'),
          },
          {
            name: 'result',
            path: 'result',
            meta: { role: 0 },
            component: () => import('../pages/admin/forms/result.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/auth',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('../pages/auth/Login.vue'),
      },
      {
        name: 'signup',
        path: 'signup',
        component: () => import('../pages/auth/Signup.vue'),
      },
      {
        name: 'logout',
        path: 'logout',
        meta: { role: 0 },
        component: () => import('../pages/auth/Logout.vue'),
      },
      {
        name: 'recover-password',
        path: 'recover-password',
        component: () => import('../pages/auth/RecoverPassword.vue'),
      },
      {
        name: 'recover-password-email',
        path: 'recover-password-email',
        component: () => import('../pages/auth/CheckTheEmail.vue'),
      },
      {
        path: '',
        redirect: { name: 'login' },
      },
    ],
  },
  {
    name: '404',
    path: '/404',
    component: () => import('../pages/404.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})

router.beforeEach(async (to) => {
  const publicPages = ['/auth/login', '/auth/signup', '/auth/recover-password']
  const authRequired = !publicPages.includes(to.path)
  const auth = useAuthStore()
  if (to.meta.role === 1 && auth.profile.role < 1 && auth.token) await Promise.reject()
  if (authRequired && !auth.token) {
    if (typeof to.name === 'string') {
      auth.returnUrl = to.name
    }
    return '/auth/login'
  }
})

export default router
